module.exports = __webpack_public_path__ + "static/media/19ESCAP2.b8198894.jpg";